import styled, { css } from "styled-components/macro";

export const AboutMeDiv = styled.fieldset`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
`;
export const GenderGrid = styled.div<{ warn?: boolean }>`
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 170px);
  justify-items: start;
  border: none;
  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  ${(props) =>
    props.warn &&
    css`
      border: 1px solid red;
    `};
`;
export const ExpirienceGrid = styled.div`
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 24px;
  justify-items: start;
  span {
    word-break: break-word;
  }
`;
